export default "__VITE_ASSET__DfqvPNj2__"